function getDefaultState() {
  return {
    serverIp: '',
  };
}

export default {
  namespaced: true,

  state: getDefaultState(),

  mutations: {
    setServerIp(state, newIp) {
      state.serverIp = newIp;
    }
  },
  actions: {
    updateServerIp({ commit }, newIp) {
      commit('setServerIp', newIp);
    }
  },
  getters: {
    getServerIp: state => state.serverIp,
  }
};
